import { Tabs, TabList, Tab } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { useAtom } from 'jotai'
import { purchaseTypeAtom } from '@!/atoms/paymentAtom'

export const PaymentTabs = () => {
  const navigate = useNavigate()
  const [purchaseType] = useAtom(purchaseTypeAtom)

  const tabIndex = purchaseType === 'monthly' ? 0 : 1

  const handleTabChange = (index) => {
    if (index === 0) {
      navigate('/monthly_course')
    } else if (index === 1) {
      navigate('/coin')
    }
  }
  return (
    <Tabs variant="unstyled" index={tabIndex} onChange={handleTabChange}>
      <TabList mx={4} mb={4} bg="bg.tertiary" borderColor="bg.tertiary" borderWidth="1px" borderRadius="md">
        <Tab fontSize="xs" w="50%" p="6px" borderWidth="1px" borderRadius="md" _selected={{ bg: 'label.white', fontWeight: '600' }}>
          月額コース登録
        </Tab>
        <Tab fontSize="xs" w="50%" p="6px" borderWidth="1px" borderRadius="md" _selected={{ bg: 'label.white', fontWeight: '600' }}>
          コイン追加購入
        </Tab>
      </TabList>
    </Tabs>
  )
}
